import { IAssessmentComposite } from "@/modules/assessments/hooks/use-get-assessment-composites-by-invite.hook";
import AssessmentTemplateCardGridItem from "@/shared/components/assessment/AssessmenTemplateCardLayout/AssessmentTemplateCardGridItem";
import AssessmentTemplateCardGrid from "@/shared/components/assessment/AssessmenTemplateCardLayout/AssessmentTemplateCardGrid";
import CompositeCard from "@/shared/components/assessment/CompositeCard/CompositeCard";
import { Col } from "antd";
import ScaleAnalyses from "../ScaleAnalyses/ScaleAnalyses";
import { IScaleAnalysis } from "@/modules/assessments/hooks/use-get-invite-scale-analyses.hook";

interface AssessmentTemplateOverallProps {
  templateComposites: IAssessmentComposite[];
  scaleAnalyses: IScaleAnalysis[];
}

export default function AssessmentTemplateOverall({
  templateComposites,
  scaleAnalyses,
}: AssessmentTemplateOverallProps) {
  const overallComposites = templateComposites.filter((composite: IAssessmentComposite) => composite.isOverall);

  return (
    <>
      <Col span={24}>
        <AssessmentTemplateCardGrid>
          {overallComposites.map((overallComposite, index) => (
            <AssessmentTemplateCardGridItem key={overallComposite.compositeKey} fullWidth={index === 0}>
              <CompositeCard composite={overallComposite} />
            </AssessmentTemplateCardGridItem>
          ))}
        </AssessmentTemplateCardGrid>
      </Col>
      <Col span={24}>
        <ScaleAnalyses scaleAnalyses={scaleAnalyses} />
      </Col>
    </>
  );
}
